// https://gist.github.com/getify/3004342
//
const ids = {};

function requestId(){
  let id;
  do {
    id = Math.floor(Math.random() * 1E9);
  } while (id in ids);
  return id;
}

export default function requestNextAnimationFrame(callback, element) {
  const id = requestId();

  ids[id] = requestAnimationFrame(() => {
    ids[id] = requestAnimationFrame(ts => {
      delete ids[id];
      callback(ts);
    },element);
  },element);

  return id;
}
